<template>
  <div class="space-y-4">
    <TheWizardNavItem v-for="(step,i) in wizardSteps" :key="i+1"
                      :completed="i+1 < current_step"
                      :current="current_step === i+1"
                      :index="i+1"
                      :title="step.title"
                      :text="step.text"/>
  </div>
</template>

<script>
import TheWizardNavItem from "@/components/cabinet/Wizard/TheWizardNav/TheWizardNavItem";

export default {
  name: "TheWizardNav",
  components: {TheWizardNavItem},
  props: {
    current_step: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      wizardSteps: [
        {
          title: this.$t('step1Title'),
          text: this.$t('step1Text'),
        },
        {
          title: this.$t('step2Title'),
          text: this.$t('step2Text'),
        },
        {
          title: this.$t('step3Title'),
          text: this.$t('step3Text'),
        },
        {
          title: this.$t('step4Title'),
          text: this.$t('step4Text'),
        },
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        step1Title: 'Accounts',
        step1Text: 'Account is where your money is located: wallet, credit cards, bank accounts, e-currencies and crypto wallets.',
        step2Title: 'Sources of Income',
        step2Text: 'Where does the money come from: salary, bonuses, freelancing, rentals, social benefits or gifts.',
        step3Title: 'Expense Categories',
        step3Text: 'Create a system of expense categories that is convenient for you. You can use groups or just use a minimal set. ',
        step4Title: 'Done!',
        step4Text: 'Find out what else MoneyKeeper has to offer to meet your financial goals and use all the possibilities 100%',
      },
      ru: {
        step1Title: 'Счета',
        step1Text: 'Счет - место, где находятся ваши деньги: кошелек, кредитки, банковские счета, электронные валюты и крипто-кошельки.',
        step2Title: 'Источники доходов',
        step2Text: 'Откуда к вам приходят деньги: зарплата, бонусы,  фриланс, сдача в аренду, социальные выплаты или подарки.',
        step3Title: 'Категории расходов',
        step3Text: 'Создайте удобную вам систему категорий расходов. Можете использовать группы или ограничиться минимальным набором.',
        step4Title: 'Готово!',
        step4Text: 'Узнайте, что еще предлагает MoneyKeeper для достижения ваших финансовых целей и используйте все возможности на 100%',
      }
    }
  }
}
</script>